var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-input-number", {
    attrs: {
      value: _vm.value,
      disabled: _vm.disabled,
      precision: _vm.precision,
      "controls-position": "right"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }